import emptySharedItemsSrc from 'Assets/images/empy-states/empty-shared-items.png?inline';
import { SharedItemsEmptyStateProps } from 'Modules/sharedItems/components/SharedItemsEmptyState/index.types';
import React from 'react';
import { EmptyState } from '~/lib/ui/emptyState';

export const SharedItemsEmptyState: React.FC<SharedItemsEmptyStateProps> = ({
  title,
  description,
  descriptionClassName = 'whitespace-pre-line',
}) => (
  <div className="flex min-h-0 flex-1 items-center justify-center">
    <EmptyState
      illustration={
        <img src={emptySharedItemsSrc} alt="" aria-hidden width={329} />
      }
      title={title}
      description={description}
      descriptionClassName={descriptionClassName}
      testID="shared-items"
    />
  </div>
);
